import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const MessageFilledIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3211 0.5C19.7273 0.5 20.8211 1.63281 20.8211 3V14.1719C20.8211 15.5 19.6883 16.6328 18.3211 16.6328H12.6961L7.81328 20.3047C7.50078 20.5 7.07109 20.3047 7.07109 19.9141V16.6719H3.32109C1.91484 16.6719 0.821094 15.5781 0.821094 14.2109V3C0.821094 1.63281 1.91484 0.5 3.32109 0.5H18.3211ZM5.82109 9.875C6.52422 9.875 7.07109 9.28906 7.07109 8.625C7.07109 8 6.48516 7.41406 5.82109 7.41406C5.11797 7.41406 4.57109 8 4.57109 8.625C4.57109 9.28906 5.11797 9.875 5.82109 9.875ZM10.8211 9.875C11.5242 9.875 12.0711 9.28906 12.0711 8.625C12.0711 8 11.4852 7.41406 10.8211 7.41406C10.118 7.41406 9.57109 8 9.57109 8.625C9.57109 9.28906 10.118 9.875 10.8211 9.875ZM15.8211 9.875C16.5242 9.875 17.0711 9.28906 17.0711 8.625C17.0711 8 16.4852 7.41406 15.8211 7.41406C15.118 7.41406 14.5711 8 14.5711 8.625C14.5711 9.28906 15.118 9.875 15.8211 9.875Z"
        fill="#00B6B9"
      />
    </SvgIcon>
  );
};

export default MessageFilledIcon;
